export default __webpack_public_path__ + "static/media/waterMark.e90f1936.svg";